interface Properties {
  [key: string]: string;
}

interface Permissions {
  [key: string]: string;
}

class UserManager {
  private static properties: Properties = {};
  private static permissions: Permissions = {};
  private static isInitialized: boolean;
  constructor(userProperties) {
    UserManager.isInitialized = true;
    UserManager.properties = {};
    userProperties.forEach((item) => {
      if (item.Name === 'permissions') {
        UserManager.setPermissions(item.Value);
      } else {
        UserManager.properties[item.Name] = item.Value;
      }
    });
  }

  public static setProperty(name: string, value: string) {
    UserManager.properties[name] = value;
  }

  public static deleteProperty(name: string) {
    delete UserManager.properties[name];
  }

  public static getProperties() {
    return UserManager.properties;
  }

  public static isSuperAdmin() {
    return (
      UserManager.properties['isSuperAdmin']?.toUpperCase() === 'TRUE' ?? false
    );
  }

  public static setPermissions(permissionsStr: string) {
    if (!permissionsStr) return;

    UserManager.permissions = {};
    permissionsStr.split(',').forEach((entry) => {
      UserManager.permissions[entry] = entry;
    });
  }

  public static addPermission(permission: string) {
    if (!permission) return;
    UserManager.permissions[permission] = permission;
  }

  public static hasPermission(permissions: string | string[]) {
    if (!Array.isArray(permissions)) permissions = [permissions];

    return !UserManager.isInitialized || UserManager.isSuperAdmin()
      ? true
      : Object.values(UserManager.permissions).some((value) =>
          permissions.includes(value)
        );
  }

  public static getPermissions() {
    return UserManager.permissions;
  }
}

export default UserManager;
